import { MonoTypeOperatorFunction } from 'rxjs';
import { filter } from 'rxjs/operators';

export function onlyTruthy<T>(): MonoTypeOperatorFunction<T> {
	return filter((x: T): boolean => !!x);
}
export function onlyFalsy<T>(): MonoTypeOperatorFunction<T> {
	return filter((x: T): boolean => !x);
}
export function notNull<T>(): MonoTypeOperatorFunction<T> {
	return filter((x: T): boolean => x !== null);
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
